import type { NamespaceLearnTranslation } from '../../i18n-types';

const de_learn = {
  agreementPopup: {
    agreementConfirmation:
      'Bitte beachten Sie, dass durch Klicken auf <>"Ich stimme zu"<>',
    button: {
      agree: 'Ich stimme zu, weiter',
      disagree: 'Nein danke',
    },
    joiningNetwork:
      'Sie sind dabei, unserem Netzwerk von Dermatoskopie-Profis, einer Fallbibliothek und vielem mehr beizutreten.',
    readPrivacyAndTerms: {
      and: 'und',
      privacyPolicy: 'Datenschutzerklärung',
      readAndUnderstood:
        'bestätigen Sie, dass Sie die Datenschutzerklärung und die Nutzungsbedingungen von Dermloop gelesen und verstanden haben',
      termsOfUse: 'Nutzungsbedingungen',
    },
    title: 'Nutzungsbedingungen & Datenschutzerklärung',
  },
  casesScreen: {
    correctnessTag: '{correct|{true: Richtig, *: Falsch}}',
    difficulty: {
      easy: 'Einfach',
      hard: 'Schwierig',
      medium: 'Mittel',
      noDifficulty: 'Keine',
      veryHard: 'Sehr schwierig',
    },
    list: {
      trainingPlaceholder: 'Abgeschlossene Fälle werden hier aufgelistet',
    },
    points: 'Punkt{{count:e}}',
    title: {
      anamnesis:
        '{gender|{Male: Mann, Female: Frau, *: Person}} in {gender|{Male: seinem, Female: ihrem, *: deren}} {age}ern',
    },
    trainingCase: {
      feedbackHeader: {
        difficulty: 'Schwierigkeit',
        partiallyCorrectInfo: {
          title: 'Nicht korrekt',
          messageLine1:
            'Die Antwort ist <>nicht korrekt<>, gehört aber zur richtigen Kategorie.',
          messageLine2: 'Es werden <>0<> Punkte vergeben.',
          dismiss: 'Verstanden',
        },
        seeExplanation: 'Erklärung & Tipps ansehen',
      },
    },
  },
  courseScreen: {
    lesson: {
      type: '{lessonType|{Quiz: Quiz, Reading: Lesen}}',
    },
    level: {
      levelNumber: 'Level {level}',
    },
  },

  diagnosisStatisticDetailScreen: {
    analyticSection: {
      content: {
        completedCases: 'Abgeschlossene Fälle',
        overallAccuracy: 'Erfolgsrate',
      },
      title: 'Statistiken zur Diagnosegruppe',
    },
    commonMistakeSection: {
      title: 'Ihre häufigsten Fehler bei {diagnosisName|lowercase}',
    },
    learnMoreSection: {
      content: {
        readMore: 'Mehr über {diagnosisName|lowercase} lesen',
      },
      title: 'Mehr erfahren',
    },
    subDiagnosisSection: {
      title: 'Subdiagnosen von {diagnosisName}',
    },
  },
  general: {
    backText: 'Zurück',
    homeText: 'Startseite',
    button: {
      restartApp: 'App neu starten',
    },
    diagnosisItem: {
      read: 'Lesen',
      whatToRead: 'Was möchten Sie lesen?',
    },
    doneReading: 'Fertig gelesen',
    markAsRead: 'Als gelesen markieren',
  },
  homeScreen: {
    dahtNudgePopup: {
      description:
        'Sie haben Ihr Ziel des Dermatoskopie-Trainings für die DAHT-Studie erreicht. Bitte gehen Sie zu daht.dermloop.io, um die DAHT-Fälle zu bewerten und die Studie abzuschließen.',
      buttonText: 'Zu DAHT gehen',
      dismissText: 'In Learn fortfahren',
      title: 'DAHT-Training abgeschlossen',
    },
    controlGroupLocked: {
      title: 'Learn gesperrt',
      description:
        'Sie erhalten Zugang zu dieser App, sobald Sie die Mindestanzahl an DAHT-Fällen abgeschlossen haben. Gehen Sie zu daht.dermloop.io',
    },
    trainingCard: {
      actionTitle: 'Quiz {started|{true: fortsetzen, false: starten}} ',
      notificationText:
        'Sie werden bald Benachrichtigungen erhalten, wenn Sie klinisches Feedback bekommen oder jemand auf einen Forum-Fall reagiert, den Sie verfolgen.',
      reminderText:
        '🔔 Es wird auch möglich sein, tägliche Erinnerungen für Lernziele zu aktivieren. 🤓',
    },
    currentLevelCard: {
      currentLevel: 'Aktuelles Level',
      accuracy: 'Level-Genauigkeit',
    },
    trainingStats: {
      title: 'Trainingsfortschritt',
      last7Days: 'Wöchentliche Fälle',
      total: 'Fälle gesamt',
    },
    dahtProgressCard: {
      title: 'Meine Ziele',
      dahtStatusIndicator: {
        onTrack: 'Auf Kurs',
        atRisk: 'Gefährdet',
        challengeEnded: 'Challenge beendet',
        challengeCompleted: 'Challenge abgeschlossen',
      },
      weeklyCases: 'Wöchentliche Fälle',
      totalProgress: 'Gesamtfortschritt',
      finalProgress: 'Endgültiger Fortschritt',
      totalCases: 'Fälle gesamt',
      studyChallenge: '28-Tage-Studien-Challenge',
      daysLeft: 'Noch {days} Tag{{e}}',
      challengeCompletedMessage:
        'Sie haben es geschafft! Vielen Dank für Ihren Beitrag. Jetzt ist es an der Zeit, DAHT-Fälle zu bewerten. Bitte besuchen Sie die Website: daht.dermloop.io',
      challengeEndedMessage:
        'Leider haben Sie nicht alle Fälle innerhalb des Zeitrahmens abgeschlossen. Sie können die verbleibenden Fälle gerne bewerten, wenn Sie DAHT-Fälle außerhalb des Protokolls auswerten möchten.',
    },
    articlesProgressCard: {
      title: 'Lesefortschritt',
      articlesCount: '{done}/{total} Artikel',
      ongoingArticlesLabel: 'Mach weiter, wo du aufgehört hast',
      getStartedLabel: 'Loslegen',
      seeAll: 'Alle anzeigen',
      bottomSheetTitle: 'Laufende Artikel',
      itemsCount: '{count} Einträge',
    },
  },
  loginScreen: {
    loginText: 'Anmelden / Loslegen',
    loginFailedMessage:
      'Wir konnten Sie nicht anmelden. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support, wenn das Problem weiterhin besteht.',
  },
  settingsScreen: {
    accountSection: {
      content: {
        changePassword: 'Passwort ändern',
        changePasswordAlert: {
          message:
            'Eine E-Mail mit Infos zum Zurücksetzen des Passworts wurde an <>{email}<> gesendet.',
          title: 'Link zum Zurücksetzen des Passworts gesendet!',
        },
        changePasswordErrorAlert: {
          message: 'Etwas ist schiefgelaufen',
          title: 'Oh nein!',
        },
        deleteAccount: 'Konto löschen',
      },
      title: 'Konto',
    },
    supportSection: {
      content: {
        contactUs: 'Kontaktieren Sie uns',
      },
      title: 'Support',
    },
    legalSection: {
      content: {
        privacyPolicy: 'Datenschutzerklärung',
        termsOfService: 'Nutzungsbedingungen',
      },
      title: 'Nutzungsbedingungen',
    },
    loggedInAs: 'Angemeldet als',
    logout: 'Abmelden',
    title: 'Einstellungen',
  },
  moreScreen: {
    title: 'Mehr',
    getHelpSection: {
      title: 'Hilfe erhalten',
      content: {
        reportProblem: 'Ein Problem melden',
        giveFeedback: 'Feedback geben',
      },
    },
    linksSection: {
      title: 'Links und Informationen',
      content: {
        shareLearn: 'Learn teilen',
        aboutMelatech: 'Über Melatech',
      },
    },
    productsSection: {
      title: 'Weitere Produkte entdecken',
      content: {
        exploreDermloop: 'Dermloop entdecken',
        exploreSeranote: 'Seranote entdecken',
      },
    },
    feedbackForm: {
      nameLabel: 'Name',
      namePlaceholder: 'Ihr Name',
      emailLabel: 'E-Mail',
      emailPlaceholder: 'ihre.email@beispiel.de',
      cancelButtonLabel: 'Abbrechen',
      isRequiredLabel: '(erforderlich)',
      errorTitle: 'Fehler',
      formError: 'Bitte füllen Sie alle Pflichtfelder aus.',
      emailError: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
      genericError:
        'Feedback konnte aufgrund eines unerwarteten Fehlers nicht gesendet werden.',
      successMessageText: 'Vielen Dank für Ihre Meldung!',
      addScreenshotButtonLabel: 'Screenshot hinzufügen',
      removeScreenshotButtonLabel: 'Screenshot entfernen',
      captureScreenshotError: 'Screenshot konnte nicht aufgenommen werden',
      reportProblem: {
        formTitle: 'Ein Problem melden',
        messageLabel: 'Beschreibung',
        messagePlaceholder: 'Beschreiben Sie das Problem kurz...',
        submitButtonLabel: 'Meldung senden',
      },
      giveFeedback: {
        formTitle: 'Feedback geben',
        messageLabel: 'Ihr Feedback',
        messagePlaceholder: 'Teilen Sie uns Ihre Gedanken mit...',
        submitButtonLabel: 'Feedback senden',
      },
    },
  },
  statisticsScreen: {
    cardInfoTitle: {
      completedCases: 'Abgeschlossene Fälle',
    },
    levelProgress: {
      accuracy: 'Genauigkeit',
      currentLevel: 'Aktuelles Level',
      noCasesYet: 'Noch keine Fälle',
      points: 'Punkt{{count:e}}',
      seeLess: 'Weniger anzeigen',
      seeMore: 'Mehr anzeigen',
    },
    diagnosisGroupDetail: '{count} Fall{{count:e}} • {accuracy}% Genauigkeit',
    sectionTitle: {
      diagnosticAccuracy: 'Diagnostische Genauigkeit',
      diagnosticGroups: 'Diagnosegruppen',
      levelProgress: 'Level-Fortschritt',
    },
  },
  tabs: {
    cases: 'Fälle',
    home: 'Startseite',
    statistics: 'Statistik',
    theory: 'Theorie',
  },
  theoryScreen: {
    searchPlaceholder: 'Artikel suchen',
    allArticles: 'Alle Artikel',
    readButton: 'Lesen',
    articleStatus: {
      notStarted: 'Nicht begonnen',
      inProgress: 'In Bearbeitung',
      done: 'Erledigt',
    },
  },
  trainingScreen: {
    diagnosisLibrarySearch: 'Artikel durchsuchen',
    practiceList: {
      courseSection: {
        itemDescription: 'Kurs',
        sectionTitle: 'Kurse',
      },
      quizSection: {
        itemTitle: 'Diagnostik üben',
        nrOfCase: '{nrOfCases} Fall{{e}}',
        sectionTitle: 'Schnellstart',
      },
      sectionType: {
        course: 'Kurs',
        quiz: 'Quiz',
      },
      startButton: '{started|{true: Fortsetzen, *: Start}}',
      title: 'Übersicht',
    },
    title: {
      diagnosisLibrary: 'Diagnosebibliothek',
      practice: 'Üben',
    },
  },
  trainingSession: {
    anamnesis:
      '{gender|{Male: Mann, Female: Frau, *: Person}} circa {age} Jahre alt',
    annotation: {
      noAnnotationCard: {
        continueButton: 'Sie haben eine Erklärung angefordert',
        description:
          'Für diesen Trainingsfall liegen keine Annotationen vor. Sie können aber eine Erklärung anfordern und wir werden die Läsion schnellstmöglich annotieren.',
        requestButton: 'Erklärung anfordern',
        title: 'Es tut uns leid!',
      },
      notDisplayed: 'Nicht angezeigt',
      title: 'Erklärung',
    },
    assessed: {
      correctAnswer: 'Richtige Antwort',
      yourAnswer: 'Ihre Antwort',
    },
    backText: 'Zurück',
    difficultyLevelChange: {
      failure: {
        continueButton: 'Mit Level {level} fortfahren',
        description:
          'Wir empfehlen dir, zu Level {level} zurückzukehren und einfachere Fälle zu üben',
        downgradeButton: 'Zurück zu Level {level}',
        title: 'Ups – Ihre Erfolgsrate liegt unter {accuracy} %!',
      },
      levelDescription: 'Level {level} – {levelName}!',
      nextLevel: {
        title: 'Sie befinden sich jetzt in',
      },
      progressionRequirement: {
        accuracyForCases: 'Erfolgsrate ({nrOfCases} Fall{{e}})',
        minAccuracy: 'Min. {accuracy}%',
        title: 'Anforderungen zum Abschließen des Levels:',
      },
      success: {
        continueButton: 'Weiter',
        description: 'Sie sind fertig',
        title: 'Glückwunsch!',
      },
    },
    footerConfirmButton: 'Antwort prüfen',
    footerContinueButton: 'Weiter',
    goback: 'Zurückgehen',
    quizError: 'Beim Starten des Quiz ist ein Fehler aufgetreten',
    quizNumber: 'Quiz #{number}',
    reportProblem: {
      cancel: 'Abbrechen',
      close: 'Schließen',
      description: 'Bitte beschreiben Sie das Problem',
      problemTextFieldPlaceholder: 'Beschreiben Sie das Problem kurz hier...',
      submit: 'Senden',
      submitted: {
        error:
          'Beim Absenden Ihrer Meldung ist ein Fehler aufgetreten. Unsere Entwickler wurden informiert. Bitte versuchen Sie es erneut.',
        success:
          'Ihre Meldung wurde übermittelt. Vielen Dank für Ihr Feedback.',
      },
      title: 'Ein Problem melden',
    },
    selectDiagnosis: 'Diagnose auswählen',
    statistic: {
      accuracyHeading: 'Diagnostische Genauigkeit',
      averageDifficulty: 'Durchschnittlicher Schwierigkeitsgrad',
      cases: 'Fälle',
      correctAnswers: 'Richtige Antworten',
      correctAnswersRatio: 'Richtige Antworten • {correct}/{total}',
      courseAccuracyCard: {
        courseFailureButton: 'Lektion wiederholen',
        courseSuccessButton: 'Nächste Lektion',
      },
      level: 'Sitzungslevel',
      points: '{count} Punkt{{e}}',
      quizAccuracyCard: {
        nextSessionButton: 'Nächstes Quiz',
      },
      quizResultHeader: 'Sitzungsergebnis',
      secondAbbreviated: 'Sek.',
      seeMore: 'Mehr anzeigen',
      time: 'Zeit pro Fall',
      timePerCase: 'Zeit pro Fall (Sek.)',
      title: 'Statistik',
    },
  },
} satisfies NamespaceLearnTranslation;

export default de_learn;
